import React from 'react';

export default (Component, file) => (props) => (
    <Component file={file} {...props} />
);
